import _slicedToArray from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectSpread from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.splice.js";
import { getGEOdata } from "@/api/bizBillingdata"; //  此处请自行替换地址
import QMap from "@/components/queryMap";
// import QChart from "@/components/queryChart";
// import TopChart from "@/components/topChart";
import HCharts from "@/components/hCharts";
import DataEmpty from "@/components/dataEmpty";
import { formatTimeToStr } from "@/utils/date";
import { mapGetters } from 'vuex';
import { getHcTplCountByTeam } from '@/api/biz_hc_tpl';
import { getHcTaskStat } from "@/api/biz_hc_task";
import { getZoneCountByTeam } from "@/api/zone";
import { getSysOperationRecordList } from "@/api/sysOperationRecord";
import { getHcTaskList } from "@/api/biz_hc_task";
export default {
  name: "Dashboard",
  inject: ['reload'],
  data: function data() {
    var _this = this;
    return {
      zoneCount: 0,
      tplCount: 0,
      totalHcTaskCount: 0,
      upHcTaskCount: 0,
      downHcTaskCount: 0,
      qData: {
        loading: true,
        total: 0,
        dataZoomShow: false
      },
      allTimes: [],
      pointIndex: 0,
      topRangeDate: [],
      mapData: {
        loading: true,
        total: 0
      },
      pickerOptions: {
        shortcuts: [{
          text: this.$t('dashborad.date-option.last-4h'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 4);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-24h'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-3d'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 3);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-1w'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-3w'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 21);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('dashborad.date-option.last-1m'),
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }],
        onPick: function onPick(_ref) {
          var maxDate = _ref.maxDate,
            minDate = _ref.minDate;
          _this.choiceDate = minDate.getTime();
          if (maxDate) {
            _this.choiceDate = '';
          }
        },
        disabledDate: function disabledDate(time) {
          if (_this.choiceDate) {
            var one = 30 * 24 * 3600 * 1000;
            var minTime = _this.choiceDate - one;
            var maxTime = _this.choiceDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      dateRange: [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1), new Date().getTime()],
      geoDateRange: [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1), new Date().getTime()],
      mapSelectDate: ['1h', '24h', '30d'],
      mapSelectedDate: '24h',
      activities: [],
      hcTasks: [],
      toolMenus: [{
        label: this.menusTitle("域名解析"),
        icon: "el-icon el-icon-document-copy",
        name: "zone",
        color: "#69c0ff",
        bgcolor: "#d8ebfd"
      }, {
        label: this.menusTitle("监控模板"),
        icon: "el-icon el-icon-coin",
        name: "hcTpl",
        color: "#5cdbd3",
        bgcolor: "#D8F3F1"
      }, {
        label: this.menusTitle("监控任务"),
        icon: "el-icon el-icon-s-flag",
        name: "hcTask",
        color: "#ff85c0",
        bgcolor: "#FADCEB"
      }, {
        label: this.menusTitle("成员管理"),
        icon: "el-icon el-icon-user",
        name: "teamMember",
        color: "#ff9c6e",
        bgcolor: "#FBE3D6"
      }]
    };
  },
  components: {
    // QChart,
    DataEmpty: DataEmpty,
    QMap: QMap,
    // TopChart,
    HCharts: HCharts
  },
  methods: {
    //添加refreshData方法进行自动设置数据
    // async getQueries() {
    //   this.qData = { 
    //     loading: true,
    //   }
    //   const params = {
    //     start: new Date(this.dateRange[0]).getTime()/1000 | 0,
    //     end: new Date(this.dateRange[1]).getTime()/1000 | 0,
    //   }
    //   const res = await getBilldatalist(params)
    //   let times = []
    //   let counts = []
    //   let total = 0
    //   res.data.map((info) => {
    //     this.allTimes.push(info.timestamp);
    //     times.push(formatTimeToStr(info.timestamp * 1000, 'MM-dd hh:mm'))
    //     counts.push(info.count)
    //     total += info.count
    //   })
    //   this.qData = { 
    //     data: [times, counts],
    //     total,
    //     dataZoomShow:true
    //   }
    //   // console.log(this.qData)
    //   // this.qData = res.data
    //   // console.log(this.qData)
    //   // this.qData = res.data.map(item => {
    //   //   const res = Object.values(item);
    //   //   // res[0]= dayjs(res[0] * 1000).format('MM-DD HH:mm')
    //   //   return res
    //   // })
    //   // console.log(this.qData)
    // },
    getMapData: function getMapData() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var params, res, resMap, total, continents, temp;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.mapData = {
                loading: true
              };
              params = {
                start: new Date(_this2.geoDateRange[0]).getTime() / 1000 | 0,
                end: new Date(_this2.geoDateRange[1]).getTime() / 1000 | 0
              };
              _context.next = 4;
              return getGEOdata(params);
            case 4:
              res = _context.sent;
              resMap = new Map();
              total = 0;
              res.data.map(function (info) {
                total += info.count;
                var k = info.continentid;
                var oldCount = resMap.get(k) | 0;
                resMap.set(k, oldCount + info.count);
              });
              continents = ['AF', 'AN', 'AS', 'EU', 'NA', 'OC', 'SA'];
              temp = [];
              continents.forEach(function (name, k) {
                var value = resMap.get(k + 1) | 0;
                var percent = 0;
                if (total != 0) {
                  percent = value * 100.00 / total;
                }
                temp.push({
                  "name": name,
                  "value": percent.toFixed(2) * 1,
                  "count": value
                });
              });
              _this2.mapData = {
                data: temp,
                total: total
              };
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    toTarget: function toTarget(name) {
      this.$router.push({
        name: name,
        query: {
          teamId: this.userInfo.lastTeamId
        }
      });
    },
    menusTitle: function menusTitle(item) {
      if (this.$te('menus.' + item)) {
        return this.$t('menus.' + item);
      }
      return item;
    },
    // translateContent(content){
    //   if(this.$i18n.locale != 'cn'){
    //     content = content.replace('被创建', this.$t('history.action-create')).replace('被修改', this.$t('history.action-modify')).replace('被删除', this.$t('history.action-delete'));
    //   }
    //   return content
    // },
    viewHcInfo: function viewHcInfo(info) {
      console.log(info);
      if (info.startsWith('task-')) {
        this.$router.push({
          name: 'hcTask',
          query: {
            id: info.replace('task-', '')
          }
        });
      } else if (info.startsWith('tpl-')) {
        this.$router.push({
          name: 'hcTpl',
          query: {
            tplName: info.replace('tpl-', '')
          }
        });
      }
    },
    changeMapDateRange: function changeMapDateRange(command) {
      this.mapSelectedDate = command;
      if (command == '1h') {
        this.geoDateRange.splice(0, 1, new Date().setTime(new Date().getTime() - 3600 * 1000 * 1 * 1));
      } else if (command == '24h') {
        this.geoDateRange.splice(0, 1, new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 1));
      } else if (command == '30d') {
        this.geoDateRange.splice(0, 1, new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30));
      }
    },
    getPointDate: function getPointDate(pointIndex) {
      this.pointIndex = pointIndex;
      this.topRangeDate = [this.allTimes[this.pointIndex] * 1000, this.allTimes[this.pointIndex] * 1000 + 5 * 60 * 1000];
    },
    getRangeDate: function getRangeDate(start, end) {
      var count = this.allTimes.length;
      var startIndex = Math.floor(count * start / 100);
      var endIndex = Math.floor(count * end / 100);
      if (endIndex == count) {
        endIndex = count - 1;
      }
      this.topRangeDate = [this.allTimes[startIndex] * 1000, this.allTimes[endIndex] * 1000];
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time != "") {
        var date = new Date(time);
        return formatTimeToStr(date * 1000, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('router', ['routerList'])), {}, {
    topDateRange: function topDateRange() {
      if (this.topRangeDate.length != 0) {
        return this.topRangeDate;
      }
      return this.dateRange;
    }
  }),
  watch: {
    // dateRange(){
    //   this.getQueries()
    // },
    routerList: function routerList() {
      this.reload();
    },
    geoDateRange: function geoDateRange() {
      this.getMapData();
    } // '$route' () {
    //   console.log("--------")
    //   // 对路由变化作出响应...
    //   // this.routerParms.list=to.query.list
    //   this.reload()
    // },
  },
  created: function created() {
    var _this3 = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var _hcTaskStat$data, _hcTaskStat$data2, _hcTaskStat$data3, _hcTasks$data, _logRes$data;
      var _yield$Promise$all, _yield$Promise$all2, zoneRes, tplRes, hcTaskStat, hcTasks, logRes;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            // this.getQueries();
            _this3.getMapData();
            _context2.next = 3;
            return Promise.all([getZoneCountByTeam(), getHcTplCountByTeam(), getHcTaskStat(), getHcTaskList({
              page: 1,
              pageSize: 8,
              status: 2
            }), getSysOperationRecordList({
              page: 1,
              pageSize: 6,
              lang: _this3.$i18n.locale
            })]);
          case 3:
            _yield$Promise$all = _context2.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 5);
            zoneRes = _yield$Promise$all2[0];
            tplRes = _yield$Promise$all2[1];
            hcTaskStat = _yield$Promise$all2[2];
            hcTasks = _yield$Promise$all2[3];
            logRes = _yield$Promise$all2[4];
            _this3.zoneCount = zoneRes.data || 0;
            _this3.tplCount = tplRes.data || 0;
            _this3.totalHcTaskCount = ((_hcTaskStat$data = hcTaskStat.data) === null || _hcTaskStat$data === void 0 ? void 0 : _hcTaskStat$data.total) || 0;
            _this3.upHcTaskCount = ((_hcTaskStat$data2 = hcTaskStat.data) === null || _hcTaskStat$data2 === void 0 ? void 0 : _hcTaskStat$data2.success) || 0;
            _this3.downHcTaskCount = ((_hcTaskStat$data3 = hcTaskStat.data) === null || _hcTaskStat$data3 === void 0 ? void 0 : _hcTaskStat$data3.fail) || 0;
            _this3.hcTasks = ((_hcTasks$data = hcTasks.data) === null || _hcTasks$data === void 0 ? void 0 : _hcTasks$data.list) || [];
            _this3.activities = ((_logRes$data = logRes.data) === null || _logRes$data === void 0 ? void 0 : _logRes$data.list) || [];
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }))();
  }
};